export const getAllActiveAppURI = '/inventory-management/getAllActiveApps';

export const getDashboardReportsURI = ({
  formattedStartDate,
  formattedEndDate,
  dimension,
  countries,
  appID,
  adUnitType,
  platform,
  sp_id,
  dp_id
}: {
  formattedStartDate: string;
  formattedEndDate: string;
  dimension: string;
  countries: string;
  appID: string;
  adUnitType: string;
  platform: string;
  // homepageOrgId: string;
  sp_id: string;
  dp_id: string;
}) => `/reporting-x/internal/sp/dashboard?start_date=${formattedStartDate}&end_date=${formattedEndDate}` +
`&dimension=${dimension}` +
`&country=${countries}` +
`&app_id=${appID}` +
`&ad_unit_type=${adUnitType}` +
`&platform=${platform}` +
  `&sp_id=${sp_id}` +
  `&dp_id=${dp_id}`;

export const getAllReportsUri = `/reporting-x/internal/sp/getAllReports`;
export const createAndSaveReportUri = `/reporting-x/internal/sp/saveReport`;
export const editAndSaveReportUri = (reportId: string) => `/reporting-x/internal/sp/editReport/${reportId}`;
export const downloadReportByIdUri = (reportId: string) => `/reporting-x/internal/sp/downloadSavedReport/${reportId}`;
export const downloadTempReportUri = `/reporting-x/internal/sp/downloadTempReport`;
export const deleteReportByIdUri = (reportId: string) => `/reporting-x/internal/sp/deleteReportById/${reportId}`;